<div class="custom-modal" [class.show]="showModal" role="dialog" aria-modal="true">
  <div class="custom-modal-backdrop"></div>

  <div class="custom-modal-dialog">
    <div class="custom-modal-content">
      <!-- ================= HEADER ================= -->
      <div class="custom-modal-header">
        <div class="modal-title-section">
          <div class="modal-icon">
            <i class="fa-solid fa-file-circle-plus"></i>
          </div>

          <div>
            <h4>New Folder</h4>
            <p>Create a new document workspace</p>
          </div>
        </div>

        <button type="button" class="close-btn" (click)="showGroupName()" aria-label="Close">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>

      <!-- ================= BODY ================= -->
      <div class="custom-modal-body">
        <!-- Error -->
        @if (isValidate) {
        <div class="error-notify">
          <div class="error-icon">
            <i class="fa-solid fa-circle-exclamation"></i>
          </div>
          <div class="error-content">
            <strong>Unable to create Folder</strong>
            <p>{{ errorDocMessage }}</p>
          </div>
        </div>
        }

        <form [formGroup]="newGroupForm" novalidate>
          <!-- ================= BASIC DETAILS ================= -->
          <div class="form-section">
            <div class="section-title">
              <i class="fa-regular fa-file-lines"></i>

              <div>
                <h5>Document Details</h5>
                <span>Enter the basic information</span>
              </div>
            </div>

            <!-- Title -->
            <div class="form-row">
              <label for="documentTitle">
                Title
                <span class="required">*</span>
              </label>

              <div class="input-wrapper">
                <i class="fa-regular fa-file"></i>

                <input id="documentTitle" class="form-input" type="text" placeholder="Enter document title"
                  formControlName="chat_group_name" (keydown)="keyDownHandler($event)" autocomplete="off" />
              </div>

              <form-validation [control]="newGroupForm.controls.chat_group_name">
              </form-validation>
            </div>

            <!-- Description -->
            <div class="form-row">
              <label for="documentDescription">
                Description
                <span class="optional">Optional</span>
              </label>

              <div class="textarea-wrapper">
                <i class="fa-regular fa-message"></i>

                <textarea id="documentDescription" class="form-textarea" placeholder="Add a short description..."
                  formControlName="chat_description" rows="3" (keydown)="keyDownHandler($event)">
                </textarea>
              </div>

              <span class="field-hint">
                Add a brief description to help users understand this document.
              </span>
            </div>

            <!-- Model Type -->
            <div class="form-row">
              <label for="modelType">
                Model Type
                <span class="required">*</span>
              </label>

              <div class="select-wrapper">
                <i class="fa-solid fa-microchip"></i>

                <select id="modelType" class="form-select" formControlName="model_type">
                  <option value="">Select Model</option>

                  @for (item of modelTypeList; track item) {
                  <option [value]="item.value">
                    {{ item.label }}
                  </option>
                  }
                </select>

                <i class="fa-solid fa-chevron-down select-arrow"></i>
              </div>
            </div>
          </div>

          <!-- ================= ACCESS USERS ================= -->
          @if (userIdList) {
          <div class="form-section access-section">
            <div class="section-title access-title">
              <div class="section-title-left">
                <div class="section-icon users-icon">
                  <i class="fa-solid fa-users"></i>
                </div>
                <div>
                  <h5>Access Users</h5>
                  <span>Select users who can access this document</span>
                </div>
              </div>
              @if (userIdList.length > 0) {
              <div class="selected-count">
                <i class="fa-solid fa-check"></i>
                {{ userIdList.length }} selected
              </div>
              }
            </div>
            <!-- User list -->
            <div class="user-list-container" infinite-scroll [infiniteScrollDistance]="modalScrollDistance"
              [infiniteScrollThrottle]="modalScrollThrottle" [scrollWindow]="false" (scrolled)="fetchNextUserList()">
              <!-- No users -->
              @if (totalRowCount === 0) {
              <div class="no-users">
                <div class="no-users-icon">
                  <i class="fa-regular fa-user"></i>
                </div>
                <strong>No users found</strong>
                <span> There are no users available to assign. </span>
              </div>
              } @else {
              <ul class="user-list">
                @for (user of listOfUsers; track user) {
                <li class="user-item" [class.selected]="userIdList.indexOf(user.user_id) > -1"
                  (click)="selectUserId(user.user_id)">
                  <div class="user-avatar">
                    <i class="pi pi-user"></i>
                  </div>
                  <div class="user-info">
                    <span class="user-name">
                      {{ user.first_name + " " + user.last_name }}
                    </span>
                    <span class="user-status">
                      {{
                      userIdList.indexOf(user.user_id) > -1
                      ? "Access granted"
                      : "Click to select"
                      }}
                    </span>
                  </div>
                  <div class="user-check" [class.visible]="userIdList.indexOf(user.user_id) > -1">
                    <i class="fa-solid fa-check"></i>
                  </div>
                </li>
                }
              </ul>
              }
              <!-- User data -->
            </div>
          </div>
          }
        </form>
      </div>

      <!-- ================= FOOTER ================= -->
      <div class="custom-modal-footer">
        <div class="footer-info">
          <i class="fa-solid fa-circle-info"></i>
          <span>Required fields are marked with *</span>
        </div>

        <div class="footer-actions">
          <button type="button" class="btn btn-cancel" (click)="showGroupName()">
            Cancel
          </button>

          <button type="button" class="btn btn-primary" [disabled]="!newGroupForm.valid"
            (click)="addNewClassRoom(newGroupForm.value)" *ngIf="!isLoading">
            <i class="fa-solid fa-check"></i>

            Create Folder
          </button>
           <button type="button" class="btn btn-primary" *ngIf="isLoading">
            <i class="fa fa-circle-o-notch"></i>

            Loading...
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
